import React, { Component } from 'react';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import moment from 'moment';
import _ from 'lodash';
import { cssNumber } from 'jquery';

class DateInputComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inner: undefined,
    };
  }

  static getDerivedStateFromProps(props, currentState) {
    const { value } = props;
    if (JSON.stringify(value) != JSON.stringify(currentState.value)) {
      const inner = value ? moment(value).format('DD/MM/YYYY') : undefined;
      return {
        inner,
        value,
      };
    }
    return null;
  }

  handleChange(e) {
    const { props } = this;
    const { value } = e.target;
    this.setState({ inner: value });

    let date = moment(value, 'DD/MM/YYYY');

    if (!value.includes('_') && date.isValid()) {
      props.onChange({
        value: date.toDate(),
        e,
        target: this,
      });
    } else if ((value.match(/[^\/\d]/g) || []).length == 8) {
      props.onChange({
        value: '',
        e,
        target: this,
      });
    }
  }

  handleBlur(e) {
    const { value } = e.target;

    let date = moment(value, 'DD/MM/YYYY');

    if (value.includes('_')) {
      this.setState({ inner: '', value: '' });
    }

    if (!date.isValid() && !value == ' ') {
      this.setState({ inner: '', value: '' });
      _alert.warning('Selecione uma data válida');
    }
  }

  render() {
    const { props } = this;
    const { inner } = this.state;

    const { name } = props;

    return (
      <MaskedTextBox
        mask={'99/99/9999'}
        placeholder={'__/__/____'}
        maskValidation={true}
        name={name}
        validityStyles={false}
        promptPlaceholder="true"
        value={inner || ''}
        disabled={props.disabled}
        required={props.required}
        title={props.title}
        onFocus={(e) => e.nativeEvent.target.select()}
        onChange={(e) => this.handleChange(e)}
        onBlur={(e) => this.handleBlur(e)}
      />
    );
  }
}

export default DateInputComponent;
